import { redirectIfNotAuthenticated } from '@/utils/request';
import { BASE_URL } from '@/constants/config';
import { ActiveUser } from '@/services/user';


export const FILES_ENDPOINTS = {
  upload: `${BASE_URL}api/files/upload/`,
};

class Files {
  uploadFile({
    file,
    fileId = null,
    onProgress = null,
    url = null,
    onError = () => {},
    onSuccess = () => {},
  }) {
    return new Promise((resolve, reject) => {
      const uploadedFilename = file.name;
      const formData = new FormData();
      // Files bigger then 80MB aren't supported with current nginx config
      if (file.size > 80000000) {
        reject('File is too big');
      }
      formData.append('file', file, uploadedFilename);
      formData.append('file_id', fileId);
      const xhr = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          onProgress && onProgress(100);
          if (xhr.status === 200) {
            if (onSuccess) onSuccess(JSON.parse(xhr.responseText));
            resolve('File was uploaded successfully.');
          } else {
            redirectIfNotAuthenticated(xhr);
            try {
              const response = JSON.parse(xhr.responseText);
              if (onError) onError(response)
              else reject(`Error occurred during upload. ${response?.detail?.message}.`);
            } catch {
              reject('Error occurred during upload.');
            }
          }
        }
      };

      xhr.onprogress = function (e) {
        if (e.lengthComputable) {
          onProgress && onProgress(e.loaded / e.total * 100);
        }
      };
      onProgress && onProgress(0);

      xhr.open('post', url || FILES_ENDPOINTS.upload);
      xhr.setRequestHeader('authorization', `Bearer ${ActiveUser.getToken()}`);
      xhr.send(formData);
    });
  }
}

export const FilesService = new Files();
